function getDataByFlow({ rascunho }) {
    switch (rascunho?.flow) {
        case 'aposentados_demitidos':
            return {
                nomeCompleto: rascunho.dataBeneficiario?.nomeCompleto,
            };

        case 'adicionar_titular':
        case 'selecionar_titular':
            return {
                nomeCompleto: rascunho.dataTitular?.fullName?.value,
            };

        default:
            return {};
    }
}

function createDraftRow({ row, flowLabel }) {
    const { rascunho, cpfCnpj, numeroContrato } = row;

    return {
        ...row,
        tipoOperacao: flowLabel[rascunho.flow],
        flow: rascunho.flow,
        status: 2,
        dataSet: rascunho,
        cpfCnpj,
        numeroContrato,
        ...getDataByFlow({ rascunho }),
    };
}

export default createDraftRow;
